module.exports = __webpack_public_path__ + "img/f29.1600a643.png";